
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { companyStore } from '@/store';

@Component
export default class CompanyDetailsView extends Vue {
  public loading = true;

  @Prop({ default: false }) readonly propFlat;
  @Prop({ default: true }) readonly propTradeName;
  @Prop({ required: true, type: String, default: '' }) readonly propC014_id;

  @Watch('propC014_id', { immediate: true })
  async updateC014_id(val) {
    this.c014_id = val;
    await this.loadPage();
  }

  public c014_id = 0;
  public unidadeDetails = null;

  // get franqueados() {
  //   //@ts-ignore
  //   return this.unidadeDetails.suporte.filter((item) => {
  //     if (item.cargo == "FRANQUEADO") {
  //       return item;
  //     }
  //   });
  // }

  public async loadPage() {
    this.loading = true;
    if (this.c014_id > 0) {
      this.unidadeDetails = await companyStore.getCompanyByC014_id(String(this.c014_id));
    }
    this.loading = false;
  }
}
